import { accessService } from '@shared/api';

import type { TenantPermission } from '../model/types';

export type GetPermissionsResponse = TenantPermission[];

export const getPermissions = () =>
  accessService
    .get<GetPermissionsResponse>('/tenant/permissions')
    .then((response) => response.data);
